import AppRecord from './AppRecord.js'

class Route extends AppRecord {

}
  
export default Route